import { useNotificationDetailsPath as resolveNotificationDetailsPath } from "./useNotificationDetailsPath";

export type RelatedEntityType =
  | "SECURITY_CLEARANCE"
  | "GATEPASS"
  | "VESSEL_REGISTRATION"
  | "VESSEL_CALL"
  | "MOVEMENT_SERVICE"
  | "MOVEMENT"
  | "DEPARTURE"
  | "INTERRUPTION"
  | "SHIPPING_AGENCY_TRANSFER"
  | "NITROGEN_SUPPLY"
  | "GANTRY_CRANE"
  | "PIGGING"
  | "BYPASS"
  | "BAY_HIRE_REQUEST"
  | "DRY_BULK_NOMINATION"
  | string;

export const buildNotificationDetailsPath = (
  relatedEntityType?: RelatedEntityType,
  relatedEntityId?: string,
  secondRelatedEntityId?: string,
): string | null => {
  if (!relatedEntityType || !relatedEntityId) return null;

  switch (relatedEntityType) {
    case "SECURITY_CLEARANCE":
      return `/port-security/security-clearance-request-preview/${relatedEntityId}`;
    case "GATEPASS":
      return `/gatepass/gatepass-request-preview/${relatedEntityId}`;
    case "VESSEL_REGISTRATION":
      return `/vessel-management/vessel-status/${relatedEntityId}`;
    case "VESSEL_CALL":
      return `/vessel-call/vessel-call-status/${relatedEntityId}/vessel-details`;
    case "MOVEMENT_SERVICE":
    case "MOVEMENT":
      return `/vessel-call/vessel-call-status/${secondRelatedEntityId}/movement-services/${relatedEntityId}`;
    case "DEPARTURE":
      return `/vessel-call/vessel-call-status/${secondRelatedEntityId}/departure`;
    case "INTERRUPTION":
      return `/vessel-call/vessel-call-status/${relatedEntityId}/vessel-details`;
    case "SHIPPING_AGENCY_TRANSFER":
      return `/vessel-call/vessel-call-status/${relatedEntityId}/shipping-agency-transfer`;
    case "PORT_SERVICES":
      return `/vessel-call/vessel-call-status/${secondRelatedEntityId}/port-services/${relatedEntityId}`;
    case "DISPUTE":
      return `/vessel-call/vessel-call-status/${secondRelatedEntityId}/operations/disputes`;
    case "VENDOR_LICENSE":
      return resolveNotificationDetailsPath(relatedEntityId, "VENDOR_LICENSE");
    case "PORT_OPERATOR_LICENSE":
      return resolveNotificationDetailsPath(relatedEntityId);
    case "DEFICIENCY":
      return `/deficiencies/deficiency-details/${relatedEntityId}`;
    case "NOMINATION":
      return `/vessel-nomination/nomination-details/${relatedEntityId}`;
    case "DRY_BULK_NOMINATION":
      return `/vessel-nomination/dry-bulk/${relatedEntityId}`;
    case "NITROGEN_SUPPLY":
      return `/terminal-services/fott-services/${relatedEntityId}?serviceType=NITROGEN_SUPPLY_SERVICE`;
    case "GANTRY_CRANE":
      return `/terminal-services/fott-services/${relatedEntityId}?serviceType=GANTRY_CRANE_SERVICE`;
    case "PIGGING":
      return `/terminal-services/fott-services/${relatedEntityId}?serviceType=PIGGING_SERVICE`;
    case "BYPASS":
      return `/terminal-services/fott-services/${relatedEntityId}?serviceType=BYPASS_SERVICE`;
    case "BAY_HIRE_REQUEST":
      return `/bay-hire/request-details/${relatedEntityId}`;
    default:
      return null;
  }
};
